// Redirection de l'ancienne URL Emergent vers le domaine personnalisé.
// Conserve le chemin, les paramètres de requête et l'ancre des liens existants.
//
// IMPORTANT : garder REDIRECT_TO_CUSTOM_DOMAIN = false tant que la résolution DNS
// et le certificat HTTPS de app.signaclean.fr ne sont pas vérifiés en production.
// Une fois le domaine confirmé opérationnel, passer à true puis republier.

export const CUSTOM_DOMAIN = "app.signaclean.fr";
export const REDIRECT_TO_CUSTOM_DOMAIN = true;

export function maybeRedirectToCustomDomain() {
  if (!REDIRECT_TO_CUSTOM_DOMAIN) return;
  if (typeof window === "undefined" || !window.location) return;
  const host = window.location.hostname;
  // Déjà sur le domaine cible : ne rien faire (évite toute boucle).
  if (host === CUSTOM_DOMAIN) return;
  // Rediriger uniquement depuis l'ancienne URL de production Emergent.
  // L'aperçu (*.preview.emergentagent.com) et le local restent inchangés.
  if (!host.endsWith(".emergent.host")) return;
  const target = `https://${CUSTOM_DOMAIN}${window.location.pathname}${window.location.search}${window.location.hash}`;
  window.location.replace(target);
}
